import * as React from 'react';
import { LinkButton, EmphasizedHeader, SmallText } from '../style.css';
import VerticalSpacer from '../../UI/VerticalSpacer';
import withCountryCode from '../../RoutesHoc/RoutesHoc';

import { womenUrl, menUrl, kidsUrl } from '../../../helpers/routes';

/* Components */
const SuccessView: React.ComponentType<{
  buildUrlWithCountry: (route: string) => string;
}> = ({ buildUrlWithCountry }) => (
  <>
    <VerticalSpacer desktopHeight="32px" mobileHeight="16px" />
    <EmphasizedHeader>Thank You!</EmphasizedHeader>
    <VerticalSpacer height="8px" />
    <SmallText>Now find the best prices in fashion in your inbox.</SmallText>
    <VerticalSpacer desktopHeight="32px" mobileHeight="8px" />
    <LinkButton href={buildUrlWithCountry(womenUrl)}>SHOP WOMEN</LinkButton>
    <LinkButton href={buildUrlWithCountry(menUrl)}>SHOP MEN</LinkButton>
    <LinkButton href={buildUrlWithCountry(kidsUrl)}>SHOP KIDS</LinkButton>
  </>
);

export default withCountryCode(SuccessView);
